import { AfterViewInit, Component, inject, Renderer2, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { PopupFooterComponent } from 'shared/components/molecules';

@Component({
  selector: 'app-popup-content-base',

  template: '',
})
export class PopupContentBaseComponent<T> implements AfterViewInit {
  @ViewChild(PopupFooterComponent) public customFooter: PopupFooterComponent | undefined;
  protected dialogRef = inject(MatDialogRef<PopupContentBaseComponent<T>>);
  public renderer = inject(Renderer2);

  public get contentData(): T {
    return this.dialogRef.componentInstance?.data?.contentData;
  }

  public closePopup(data?: unknown): void {
    this.dialogRef.close(data);
  }

  public ngAfterViewInit(): void {
    if (this.dialogRef && this.dialogRef.componentInstance?.data?.footerClass && this.customFooter) {
      this.renderer.addClass(
        this.customFooter.elementRef.nativeElement,
        this.dialogRef.componentInstance.data.footerClass
      );
    }
  }
}
